module.exports = __webpack_public_path__ + "img/ki.70fffea0.svg";